/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

  /* product-form.liquid */
function changeColor(variant_id, element){
  if(element.name =="option-0"){
    var divsToHide = document.getElementsByClassName("div_variant");

    for(var i = 0; i < divsToHide.length; i++){
      if (divsToHide[i]) {
        divsToHide[i].style.visibility = "hidden"; 
        divsToHide[i].style.display = "none";
      }
    }

    if (document.getElementById(variant_id)) {
      document.getElementById(variant_id).style.visibility ="visible";
      document.getElementById(variant_id).style.display = "block";
    }
  }
}

/* product-form.liquid */
/* unables add to cart button after first size selecting (click on size label) */
function updateAddToCartButton(isColorButtonClick) {
  const addToCartButton = document.querySelector(".ProductForm__AddToCart")
  if (isColorButtonClick) {
    addToCartButton.classList.add("ProductForm__AddToCart__Initial")
    addToCartButton.removeAttribute("data-action")
    addToCartButton.disabled = true

    const selectedSizeButton = document.querySelector(".SizeEdmmondList_Size input:checked")
    if (selectedSizeButton) {
      selectedSizeButton.checked = false
    }

    addToCartButton.innerHTML = window.languages.selectSize
    console.log(addToCartButton)
  } else {
    addToCartButton.classList.remove("ProductForm__AddToCart__Initial")
  }
}


document.addEventListener("DOMContentLoaded", () => {
  const addToCartButton = document.querySelector(".ProductForm__AddToCart");
  const sizeInputs = document.querySelectorAll(".SizeEdmmondList_Size input");
  const allDisabled = Array.from(sizeInputs).every(input => input.disabled);
if (allDisabled) return;

  const translations = {
    en: { add: "Add to Cart", select: "Select Size" },
    es: { add: "Añadir al carrito", select: "Selecciona talla" },
    nl: { add: "Toevoegen aan winkelwagen", select: "Selecteer maat" },
    fr: { add: "Ajouter au panier", select: "Sélectionner la taille" },
    de: { add: "In den Warenkorb", select: "Größe auswählen" },
  };

  const langAttr = document.body.getAttribute("data-language");
const lang = translations[langAttr] ? langAttr : "en";

  // Set initial button text
  addToCartButton.innerHTML = translations[lang].add;

  // Inject overlay div after button
  const overlay = document.createElement("div");
  overlay.classList.add("AddToCartOverlay");
  overlay.style.position = "absolute";
  overlay.style.top = "0";
  overlay.style.left = "0";
  overlay.style.width = "100%";
  overlay.style.height = "100%";
  overlay.style.cursor = "pointer";
  overlay.style.background = "transparent";
  overlay.style.zIndex = "10";

  // Make parent relative so overlay positions correctly
  const parent = addToCartButton.parentElement;
  parent.style.position = "relative";
  parent.appendChild(overlay);

  // Handle overlay click
  overlay.addEventListener("click", (e) => {
    const sizeSelected = Array.from(sizeInputs).some(input => input.checked);

    if (!sizeSelected) {
      e.preventDefault();
      addToCartButton.innerHTML = translations[lang].select;
      // overlay remains
    } else {
      // size selected: remove overlay and trigger button click
      overlay.remove();
      addToCartButton.click();
    }
  });

  // Remove overlay when user selects a size
  sizeInputs.forEach(input => {
    input.addEventListener("change", () => {
      addToCartButton.innerHTML = translations[lang].add;
      if (overlay.parentElement) overlay.remove();
    });
  });
});